/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Company } from './Company';
import {
    CompanyFromJSON,
    CompanyFromJSONTyped,
    CompanyToJSON,
    CompanyToJSONTyped,
} from './Company';

/**
 * 
 * @export
 * @interface OSMBuilding
 */
export interface OSMBuilding {
    /**
     * 
     * @type {string}
     * @memberof OSMBuilding
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OSMBuilding
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof OSMBuilding
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof OSMBuilding
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof OSMBuilding
     */
    companyId?: string;
    /**
     * 
     * @type {Company}
     * @memberof OSMBuilding
     */
    company?: Company;
    /**
     * 
     * @type {string}
     * @memberof OSMBuilding
     */
    geometryType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OSMBuilding
     */
    coordinates?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OSMBuilding
     */
    building?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OSMBuilding
     */
    image?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OSMBuilding
     */
    mapillary?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OSMBuilding
     */
    refBag?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OSMBuilding
     */
    source?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof OSMBuilding
     */
    sourceDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof OSMBuilding
     */
    startDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OSMBuilding
     */
    wikidata?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OSMBuilding
     */
    wikipedia?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OSMBuilding
     */
    isHighlighted?: boolean;
}

/**
 * Check if a given object implements the OSMBuilding interface.
 */
export function instanceOfOSMBuilding(value: object): value is OSMBuilding {
    return true;
}

export function OSMBuildingFromJSON(json: any): OSMBuilding {
    return OSMBuildingFromJSONTyped(json, false);
}

export function OSMBuildingFromJSONTyped(json: any, ignoreDiscriminator: boolean): OSMBuilding {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'company': json['company'] == null ? undefined : CompanyFromJSON(json['company']),
        'geometryType': json['geometryType'] == null ? undefined : json['geometryType'],
        'coordinates': json['coordinates'] == null ? undefined : json['coordinates'],
        'building': json['building'] == null ? undefined : json['building'],
        'image': json['image'] == null ? undefined : json['image'],
        'mapillary': json['mapillary'] == null ? undefined : json['mapillary'],
        'refBag': json['refBag'] == null ? undefined : json['refBag'],
        'source': json['source'] == null ? undefined : json['source'],
        'sourceDate': json['sourceDate'] == null ? undefined : (new Date(json['sourceDate'])),
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'wikidata': json['wikidata'] == null ? undefined : json['wikidata'],
        'wikipedia': json['wikipedia'] == null ? undefined : json['wikipedia'],
        'isHighlighted': json['isHighlighted'] == null ? undefined : json['isHighlighted'],
    };
}

export function OSMBuildingToJSON(json: any): OSMBuilding {
    return OSMBuildingToJSONTyped(json, false);
}

export function OSMBuildingToJSONTyped(value?: OSMBuilding | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'isActive': value['isActive'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'companyId': value['companyId'],
        'company': CompanyToJSON(value['company']),
        'geometryType': value['geometryType'],
        'coordinates': value['coordinates'],
        'building': value['building'],
        'image': value['image'],
        'mapillary': value['mapillary'],
        'refBag': value['refBag'],
        'source': value['source'],
        'sourceDate': value['sourceDate'] == null ? value['sourceDate'] : value['sourceDate'].toISOString(),
        'startDate': value['startDate'],
        'wikidata': value['wikidata'],
        'wikipedia': value['wikipedia'],
        'isHighlighted': value['isHighlighted'],
    };
}

